import type { UseFormRegister, FieldErrors } from "react-hook-form";
import type { TFunction } from "i18next";
import { Input } from "@/shared/ui";
import type { OrganizationFormValues } from "../validation";

interface Props {
  register: UseFormRegister<OrganizationFormValues>;
  errors: FieldErrors<OrganizationFormValues>;
  t: TFunction;
  disabled: boolean;
}

export default function OrganizationDirectorSection({ register, errors, t, disabled }: Props) {
  return (
    <div className="p-7 radius-3xl surface-base-fill flex flex-col gap-4">
      <h2 className="text-body-bold-lg content-base-primary pb-3 border-b surface-component-stroke">
        {t("sections.director.title")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={t("fields.directorBasis")}
          placeholder={t("placeholders.directorBasis")}
          disabled={disabled}
          error={errors.director_basis?.message ? t(errors.director_basis.message) : undefined}
          {...register("director_basis")}
        />
      </div>
    </div>
  );
}

